import React, { useCallback, useEffect, useState } from 'react';
import { Modal, Form, Button, Alert } from 'react-bootstrap';
import { ColoredModal } from '../Negocios/CaixaAprovacao/ModalAprovarReprovar/styles';
import api from '~/Services/api';
import colors from '~/Utils/Styling/colors';
import { toast } from 'react-toastify';
import { default as Selector } from 'react-select';
import { customStyles, DropdownIndicator } from '~/Styles/react-select-styles';

export default function ModalAprovarReprovarSolicitacao({
  show,
  onCancel,
  aprovando,
  solicitacoes,
  limparSolicitacoes,
  consultarSolicitacoes,
}) {
  const [justificativa, setJustificativa] = useState('');
  const [usuarios, setUsuarios] = useState([]);
  const [usuarioResponsavel, setUsuarioResponsavel] = useState();
  const [alterandoStatus, setAlterandoStatus] = useState(false);

  const fetchUsuarios = useCallback(async () => {
    try {
      const response = await api.buscarUsuarios();
      setUsuarios(response);
    } catch (error) {
      toast.error(error.message);
    }
  }, []);

  const finalizar = () => {
    limparSolicitacoes();
    setJustificativa('');
    onCancel();
  };

  const aprovar = async () => {
    try {
      setAlterandoStatus(true);
      const response = await api.aprovarSolicitacao({
        solicitacoes: solicitacoes,
        justificativa: justificativa,
      });
      if (response) {
        consultarSolicitacoes({});
        toast.success(response.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setAlterandoStatus(false);
      finalizar();
    }
  };

  const recusar = async () => {
    try {
      setAlterandoStatus(true);
      const response = await api.recusarSolicitacao({
        solicitacoes: solicitacoes.map(s => ({
          ...s,
          usuario_remanejado: s.usuario_alternativo || usuarioResponsavel,
        })),
        justificativa: justificativa,
      });
      if (response) {
        consultarSolicitacoes({});
        toast.success(response.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setAlterandoStatus(false);
      finalizar();
    }
  };

  useEffect(() => {
    fetchUsuarios();
  }, [fetchUsuarios]);

  return (
    <ColoredModal
      color={aprovando ? colors.success : colors.danger}
      show={show}
      onHide={onCancel}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {aprovando ? 'APROVAR SOLICITAÇÕES' : 'REPROVAR SOLICITAÇÕES'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant={aprovando ? 'success' : 'danger'}>
          Escreva uma justificativa para{' '}
          <strong>{aprovando ? 'aprovar' : 'reprovar'}</strong> as solicitações.
        </Alert>
        <Form.Group>
          <Form.Label>Justificativa</Form.Label>
          <Form.Control
            as="textarea"
            type="text"
            placeholder="Informe uma justificativa..."
            name="justificativa"
            onChange={e => {
              setJustificativa(e.target.value);
            }}
            maxLength={128}
          />
        </Form.Group>
        {solicitacoes.length > 0 &&
          new Set(solicitacoes.map(s => s.codigo_usuario)).size === 1 &&
          !solicitacoes[0].usuario_alternativo && (
            <Form.Group className="mb-3">
              <Form.Label>Usuário para Correção</Form.Label>
              {(() => {
                const usuarioOptions = usuarios.map(usuario => ({
                  value: usuario.codigo,
                  label: usuario.nome,
                }));
                const selected =
                  usuarioOptions.find(
                    opt => String(opt.value) === String(usuarioResponsavel)
                  ) || null;
                return (
                  <Selector
                    isDisabled={
                      solicitacoes.length > 0 &&
                      new Set(solicitacoes.map(s => s.codigo_usuario)).size !==
                        1
                    }
                    placeholder={
                      solicitacoes.length > 0 &&
                      new Set(solicitacoes.map(s => s.codigo_usuario)).size !==
                        1
                        ? 'Não é possível remanejar para diferentes usuários'
                        : 'Selecione o tipo...'
                    }
                    options={usuarioOptions}
                    value={selected}
                    onChange={selectedOption => {
                      const value = selectedOption ? selectedOption.value : '';
                      setUsuarioResponsavel(value);
                    }}
                    styles={customStyles}
                    components={{ DropdownIndicator }}
                  />
                );
              })()}
            </Form.Group>
          )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant={aprovando ? 'success' : 'danger'}
          type="submit"
          className="mb-1"
          onClick={() => {
            aprovando ? aprovar() : recusar();
          }}
          disabled={justificativa === '' || alterandoStatus}
        >
          {aprovando ? 'APROVAR' : 'REPROVAR'}
        </Button>
        <Button
          variant="outline-primary"
          disabled={alterandoStatus}
          onClick={() => {
            setJustificativa('');
            onCancel();
          }}
        >
          Cancelar
        </Button>
      </Modal.Footer>
    </ColoredModal>
  );
}
